var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',{attrs:{"title":"RDV","app-bar-class":_vm.appBarClass,"bg-class":_vm.bgClass,"dark":_vm.dark}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }